import React from "react";
import img1 from "../assets/hol3.jpg";
import SectionHeadline from "./SectionHeadline";

export default function ScholarDPH() {
  return (
    <div className=" flex justify-center items-center">
      <div className=" flex flex-col gap-5 w-full  md:w-10/12  shadow-md pb-10">
        <SectionHeadline
          title="SCHOLAR-SHIP DIPLOMA IN PHARMACY"
          backgroundImage={img1}
        />
        <div className="  md:px-10 px-4 flex justify-center items-center mt-5 md:mt-10 ">
          Holy Vision Technical Campus (HVTC) offers a distinguished scholarship
          program for the PCL in Diploma in Pharmacy (D. Pharm) program,
          specifically targeting students classified under Category 3 by the
          Council for Technical Education and Vocational Training (CTEVT). Each
          year, three students from this category are selected to receive this
          scholarship, highlighting HVTC's dedication to supporting diverse
          talent. Additionally, a separate merit-based scholarship is awarded to
          one outstanding student, recognizing exceptional academic achievement
          and potential. This dual scholarship initiative underscores HVTC's
          commitment to fostering educational opportunities and rewarding
          excellence in the field of healthcare.
        </div>
      </div>
    </div>
  );
}
